import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axiosInstance from "../../http-common";

export interface loginSessionSlice {
  data: {} | null;
  isLoggedIn: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: loginSessionSlice = {
  data: {},
  isLoggedIn: false,
  loading: false,
  error: "",
};

export const getLoginSession: any = createAsyncThunk(
  "login",
  async (logData: any) => {
    try {
      const res = await axiosInstance.post("/api/admin/login", logData);
      toast.success("User logged in successfully");
      return res.data.response.data;
    } catch (err: any) {
      if (err.response.data.errorMessage) {
        console.log(err.response.data.errorMessage);
        toast.error(err.response.data.errorMessage);
        throw new Error(err.response.data.errorMessage);
      }
      if (err.response.data.errMsg){
        console.log(err.response.data.errMsg);
        toast.error(err.response.data.errMsg);
        throw new Error(err.response.data.errMsg);
      }
      else {
        console.log(err);
        throw new Error(err);
      }
    }
  }
);

export const sessionSlice = createSlice({
  name: "loginDetails",
  initialState,
  reducers: {
    logout: (state, action) => {
      state.data = {};
      state.isLoggedIn = false;
      state.loading = false;
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getLoginSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getLoginSession.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = null;
          state.isLoggedIn = true;
          state.data = action.payload;
        }
      )
      .addCase(
        getLoginSession.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.isLoggedIn = false;
          state.error = action.payload;
          state.data = {};
        }
      );
  },
});

export const { logout } = sessionSlice.actions;
export default sessionSlice.reducer;
